export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Während des Tertials war immer klar, an wen ich mich mit Fragen wenden konnte.",
			},
			{
				id: 2,
				text: "Die Betreuung während des Tertials war optimal.",
			},
			{
				id: 3,
				text: "Die BetreuerInnen waren stets motiviert und engagiert.",
			},
			{
				id: 4,
				text: "Wenn es Probleme gab, konnten diese schnell und gut gelöst werden.",
			},
			{
				id: 5,
				text: "Die Möglichkeit zur Betreuung von PatientInnen war zufriedenstellend.",
			},
			{
				id: 6,
				text: "Es gab ausreichend viele Möglichkeiten, selbst Befunde zu erheben.",
			},
			{
				id: 7,
				text: "Bei Visiten und Befunden gab es hilfreiche Vor- und/oder Nachbesprechungen.",
			},
			{
				id: 8,
				text: "Es fanden regelmäßig Fortbildungen statt.",
			},
			{
				id: 9,
				text: "Die Qualität der Fortbildungen war zufriedenstellend.",
			},
			{
				id: 10,
				text: "Die Fortbildungen ließen sich gut in den Arbeitsalltag integrieren.",
			},
			{
				id: 11,
				text: "Ich wurde gut in die Klinik integriert.",
			},
			{
				id: 12,
				text: "Ich wurde über meine Aufgaben und bevorstehende Termine rechtzeitig informiert.",
			},
			{
				id: 13,
				text: "Ich habe vor dem Kontakt mit PatientInnen alle nötigen Informationen erhalten.",
			},
			{
				id: 14,
				text: "Es gab ein hilfreiches Eingangs-/Schlussgespräch.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 15,
				text: "Die Schwierigkeit der von mir zu erledigenden Tätigkeiten war …",
			},
			{
				id: 16,
				text: "Der Umfang der von mir zu erledigenden Tätigkeiten war …",
			},
			{
				id: 17,
				text: "Insgesamt waren die Anforderungen des Tertials …",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 18,
				text: "Insgesamt fand ich das Tertial gut.",
			},
			{
				id: 19,
				text: "Meine Erwartungen an das Tertial wurden erfüllt.",
			},
			{
				id: 20,
				text: "Ich würde das Tertial in dieser Klinik weiterempfehlen.",
			},
			{
				id: 21,
				text: "Durch das Tertial fühle ich mich gut auf die Zeit als Assistenzarzt/ärztin vorbereitet.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 22,
				text: "Wissen Sie bereits, welches Ihr späteres Fachgebiet sein soll? Hat das aktuelle Tertial Ihre Entscheidung beeinflusst?",
			},
			{
				id: 23,
				text: "Anmerkungen zu den BetreuerInnen (Lob, Kritik, Vorschläge)",
			},
			{
				id: 24,
				text: "Anmerkungen zum PJ (Lob, Kritik, Vorschläge)",
			},
		],
	},
];
